import _ from "underscore";
import {
  llmRunFilterKeys,
  LlmRunFilters,
  llmRunNumberFilterKeys,
  llmRunStringArrayFilterKeys,
  llmRunStringFilterKeys,
} from "common/flowmaster/types/llm_run";
import {parseQuery} from "utils/uri";

export default function pickLlmRunFiltersFromURL(router): LlmRunFilters {
  const params = parseQuery(router.location.search);
  return {
    ...(Object.fromEntries(
      llmRunFilterKeys.map(key => [key, null]),
    ) as LlmRunFilters),
    ..._.chain(params)
      .pick(llmRunNumberFilterKeys)
      .mapObject(item => parseInt(item, 10))
      .value(),
    ..._.chain(params).pick(llmRunStringFilterKeys).value(),
    ..._.chain(params)
      .pick(llmRunStringArrayFilterKeys)
      .mapObject(item => item)
      .value(),
    from: params.from || null,
    to: params.to || null,
    min_cost: params.min_cost || null,
    max_runs: params.max_runs || null,
    input_contains: params.input_contains,
  };
}
